const docsResources = {
  en: {
    docs: {
      'finance.title': 'Financial indicators',
      'finance.text1': 'Financial statements',
      'finance.text2': 'Audited reports',
      'registration.title': 'Certificate of re-registration',
      'registration.text': 'Certificate of state re-registration',
      'letters.title': 'Recommendation letters',
      'agents.title': 'Register of Insurance Agents',
      'agents.text':
        'Register of insurance agents of "Alatau City Garant" Insurance Company" JSC',
      'corporate.title': 'Corporate governance',
      'corporate.text1':
        'Charter of  "Alatau City Garant" Insurance Company" JSC',
      'corporate.text2':
        'Code of Professional Ethics of "Alatau City Garant "Insurance Company" JSC',
      'corporate.text3':
        'Corporate Governance Code of "Alatau City Garant "Insurance Company" JSC',
      'corporate.text4': 'Human rights, diversity and equal opportunity policy',
      'corporate.text5':
        'Policy of the responsible supplier of goods, works and services',
      'corporate.text6': 'Quality certificates',
      'corporate.text6.url':
        'https://api.jgarant.kz/cdn/441c440f7c2443f5bc7f2ba3b708a0cc.pdf',
      'requisites.title': 'Requisites',
      'requisites.subtitle':
        '"Alatau City Garant" Insurance Company" Joint Stock Company',
      'requisites.text1': 'Legal address:',
      'requisites.text2':
        '187 B.,  N. Nazarbayev Avenue,  Bostandyk district, city of Almaty,  postal code 050013/A15T6K6, Republic of Kazakhstan',
      'requisites.text3': 'Bank details:',
      'requisites.text4': 'BIN 080740012607',
      'requisites.text5': 'Sign of residency: 1 economic sector code 15',
      'requisites.text6':
        'Name of the bank: "Alatau City Bank" JSC, Almaty Branch',
      'requisites.text7': "Bank's BIC: TSESKZKA",
      'requisites.text8': 'IBAN KZ22998CTB0000078304',
      'requisites.text9': 'IIC KZ22998CTB0000078304',
      'requisites.text10': '• BIC TSES KZ KA',
      'requisites.text11': "Beneficiary's code 15",
      'direct1.title': 'Mandatory Familiarization Documents for CICL VO',
      'direct1.subtitle':
        'Before applying for mandatory car insurance, please review the information below:',
      'direct1.text1': 'Rules of Mandatory Car Insurance (CICL VO)',
      'direct1.link1':
        'https://api.jgarant.kz/cdn/e17ed594ebd64520bea88510b252587a.pdf',
      'direct1.text2':
        'Terms and Conditions of Mandatory Car Insurance Promotions',
      'direct1.text3': 'Privacy Policy',
      details: 'Details',
    },
  },
  kz: {
    docs: {
      'finance.title': 'Қаржылық көрсеткіштер',
      'finance.text1': 'Қаржылық есептілік',
      'finance.text2': 'Аудиттелген есептер',
      'registration.title': 'Қайта тіркеу туралы анықтама',
      'registration.text': 'Мемлекеттік қайта тіркеу туралы анықтама',
      'letters.title': 'Ұсыну хаттар',
      'agents.title': 'Сақтандыру агенттерінің тізілімі',
      'agents.text':
        '«Alatau City Garant» сақтандыру компаниясы» АҚ-ның сақтандыру агенттерінің тізілімі',
      'corporate.title': 'Корпоративтік басқару',
      'corporate.text1':
        '«Alatau City Garant» сақтандыру компаниясы» АҚ-ның Жарғысы',
      'corporate.text2':
        '«Alatau City Garant» сақтандыру компаниясы» АҚ-ның Кәсіби әдеп кодексі',
      'corporate.text3':
        '«Alatau City Garant» сақтандыру компаниясы» АҚ-ның Корпоративтік басқару кодексі',
      'corporate.text4':
        'Адам құқықтары, әртүрлілік және тең мүмкіндіктер саясаты',
      'corporate.text5':
        'Тауарлардың, жұмыстардың және қызметтердің жауапты жабдықтаушысының саясаты',
      'corporate.text6': 'Сапа сертификаттары',
      'corporate.text6.url':
        'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/quality-certificates_kz.pdf',
      'requisites.title': 'Деректемелері',
      'requisites.subtitle':
        '«Alatau City Garant» сақтандыру компаниясы» акционерлік қоғамы',
      'requisites.text1': 'Заңды мекенжайы:',
      'requisites.text2':
        'Қазақстан Республикасы, пошта индексі 050013/A15T6K6, Алматы қаласы, Бостандық ауданы, Н.Назарбаев даңғылы, 187 Б',
      'requisites.text3': 'Банк деректемелері:',
      'requisites.text4': 'БСН 080740012607',
      'requisites.text5': 'Резиденттік белгісі: 1 экономика секторының коды 15',
      'requisites.text6': 'Банк атауы: "Alatau City Bank" АҚ, Алматы филиалы',
      'requisites.text7': 'Банктің БСК: TSESKZKA',
      'requisites.text8': 'IBAN KZ22998CTB0000078304',
      'requisites.text9': 'ЖСК KZ22998CTB0000078304',
      'requisites.text10': 'БСК TSES KZ KA',
      'requisites.text11': 'КБЕ 15',
      'direct1.title': 'Міндетті автосақтандыру үшін міндетті танысу құжаттары',
      'direct1.subtitle':
        'Міндетті автосақтандыруды ресімдеу алдында төмендегі ақпаратпен танысуды сұраймыз:',
      'direct1.text1':
        'Міндетті автосақтандырудың сақтандыру ережелері (ОГПО ВТС)',
      'direct1.link1':
        'https://api.jgarant.kz/cdn/e627b9ed7713416fa7bfde93ef3fcc78.pdf',
      'direct1.text2': 'Міндетті автосақтандыру бойынша акциялардың шарттары',
      'direct1.text3': 'Құпиялылық саясаты',
      details: 'Толығырақ',
    },
  },
  ru: {
    docs: {
      'finance.title': 'Финансовые показатели',
      'finance.text1': 'Финансовая отчетность',
      'finance.text2': 'Аудированные отчеты',
      'registration.title': 'Справка о перерегистрации',
      'registration.text': 'Справка о государственной перерегистрации',
      'letters.title': 'Рекомендательные письма',
      'agents.title': 'Реестр страховых агентов',
      'agents.text':
        'Реестр страховых агентов АО «Страховая компания «Alatau City Garant»',
      'corporate.title': 'Корпоративное управление',
      'corporate.text1': 'Устав АО «Страховая компания «Alatau City Garant»',
      'corporate.text2':
        'Кодекс профессиональной этики АО «Страховая компания «Alatau City Garant»',
      'corporate.text3':
        'Кодекс корпоративного управления АО «Страховая компания «Alatau City Garant»',
      'corporate.text4':
        'Политика в области прав человека, разнообразия и равных возможностей',
      'corporate.text5':
        'Политика ответственного поставщика товаров, работ и услуг',
      'corporate.text6': 'Сертификаты качества',
      'corporate.text6.url':
        'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/quality-certificates.pdf',
      'requisites.title': 'Реквизиты',
      'requisites.subtitle':
        'Акционерное общество «Страховая компания «Alatau City Garant»',
      'requisites.text1': 'Юридический адрес:',
      'requisites.text2':
        'Республика Казахстан, почтовый индекс 050013/A15T6K6, город Алматы, Бостандыкский район, проспект Н. Назарбаев, 187 Б.',
      'requisites.text3': 'Банковские реквизиты:',
      'requisites.text4': 'БИН 080740012607',
      'requisites.text5': 'Признак резидентства: 1 код сектора экономики 15',
      'requisites.text6':
        'Наименование банка: АО "Alatau City Bank", Алматинский Филиал',
      'requisites.text7': 'БИК Банка: TSESKZKA',
      'requisites.text8': 'IBAN KZ22998CTB0000078304',
      'requisites.text9': 'ИИК KZ22998CTB0000078304',
      'requisites.text10': 'БИК TSES KZ KA',
      'requisites.text11': 'КБЕ 15',
      'direct1.title': 'Документы обязательного ознакомления для ОГПО ВТС',
      'direct1.subtitle':
        'Перед оформлением обязательного автострахования просим ознакомится с информацией ниже:',
      'direct1.text1':
        'Правила страхования обязательного автострахования (ОГПО ВТС)',
      'direct1.link1':
        'https://api.jgarant.kz/cdn/e17ed594ebd64520bea88510b252587a.pdf',
      'direct1.text2': 'Условия акций по обязательному автострахованию',
      'direct1.text3': 'Политика конфидициальности',
      details: 'Подробнее',
    },
  },
};

export default docsResources;
